import {useTradeNameContext} from '@/shared/contexts/trade-name'
import {AboutTabContent} from './about-tab-content'

export function AboutTab() {
  const {tradeName} = useTradeNameContext()

  return <AboutTabContent tradeName={tradeName} />
}
